<div class="mb-4" *ngIf="fb && fb.error">
  <lib-error [title]="fb.text" [error]="fb.error"></lib-error>
</div>

<ng-container *ngIf="state == 3; else notLoading">
  <div class="col-12 text-center mb-4">
    <lib-loading [status]="'text-primary'" [spinnerPosition]="true" [text]="'LDG'" [size]="'md'">
    </lib-loading>
  </div>
</ng-container>

<ng-template #notLoading>
  
  <ng-container *ngIf="state == 0">

    <p class="mb-4"><b>Customer contact is required so this customer can be created in jControl</b></p>

    <form [formGroup]="form" *ngIf="form">
      <div class="row">
        <div class="col-12">
          <div class="col-12 col-lg-5 px-0 filter-item">
            <lib-select-box [control]="form.controls.title" [source]="titles" [labelBlock]="true" [idName]="'title'"
              [label]="'Title:'" [sourceType]="'Titles' | translate">
            </lib-select-box>
          </div>
          <div class="col-12 col-lg-8 px-0 filter-item">
            <lib-text-box [control]="form.controls.firstName" [labelBlock]="true" [idName]="'first-name'"
              [label]="'First Name:'" [maxLength]="40">
            </lib-text-box>
          </div>
          <div class="col-12 col-lg-8 px-0 filter-item">
            <lib-text-box [control]="form.controls.lastName" [labelBlock]="true" [idName]="'last-name'"
              [label]="'Last Name:'" [maxLength]="40">
            </lib-text-box>
          </div>
          <div class="col-12 px-0 filter-item">
            <lib-text-box [control]="form.controls.jobTitle" [labelBlock]="true" [idName]="'job-title'"
              [label]="'Job Title:'" [maxLength]="80">
            </lib-text-box>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="col-12 px-0 filter-item">
            <lib-text-box [control]="form.controls.emailAddress" [labelBlock]="true" [idName]="'email'"
              [label]="'Email Address:'" [maxLength]="255">
            </lib-text-box>
          </div>
          
          <!--switch to alert if the form is submitted without atleast one valid phone number-->
          <div [ngClass]="formSubmitted && !isValidPhoneNumberProvided() ? 'alert alert-danger' : 'text-secondary'">

            <div class="col-12 px-0 filter-item">

                <div class="mb-3">
                    A valid telephone or mobile number is required.
                </div>

                <phone-number-input [numberObj]="{number: form.controls.telephoneNumber.value}" [isRequired]="true" [size]="'md'"
                            (numberUpdated)="numberUpdated($event, form.controls.telephoneNumber)"
                            (numberVerifiedEmit)="checkIsVerified($event, 'telephoneNumber')"
                            [label]="'Phone Number:'"
                            [defaultCountryCode]="customerAddress?.details?.countryCode ? customerAddress?.details?.countryCode : undefined">
                </phone-number-input>

            </div>
            <div class="col-12  px-0 filter-item">

                <phone-number-input [numberObj]="{number: form.controls.mobileNumber.value}" [isRequired]="true" [size]="'md'"
                            (numberUpdated)="numberUpdated($event, form.controls.mobileNumber)"
                            (numberVerifiedEmit)="checkIsVerified($event, 'mobileNumber')"
                            [label]="'Mobile Number:'"
                            [defaultCountryCode]="customerAddress?.details?.countryCode ? customerAddress?.details?.countryCode : undefined">
                </phone-number-input>

            </div>

          </div>
        </div>
      </div>
      <!--div class="row mt-3">
            <div class="col-12 d-flex flex-row">
                <div class="col-10 px-0 filter-item">
                    <lib-select-box
                        [control]="form.controls.address"
                        [source]="savedAddresses"
                        [labelBlock]="true"
                        [fieldDescription]="'concatenatedAddress'"
                        [idField]="'postalCode'"
                        [idName]="'address'"
                        [label]="'Address:'">
                    </lib-select-box>
                </div>
                <div class="col-2 px-0 text-right text-lg-center">
                    <button class="btn btn-success" (click)="addAddress()">Add</button>
                </div>
            </div>
        </div-->
      <div class="row mt-3">
        <div class="col-12">
          <div class="col-12 col-lg-8 px-0 filter-item">
            <lib-select-box [control]="form.controls.language" [source]="languages" [idField]="'code'"
              [labelBlock]="true" [idName]="'language'" [label]="'Language:'" [sourceType]="'Languages' | translate">
            </lib-select-box>
          </div>
        </div>
      </div>
      <div class="row check-box-container">
        <div class="col-12 col-lg-6 pl-0 mb-lg-3">
          <lib-check-box [control]="form.controls.isDefault" [idName]="'default-contact'" [label]="'Default Contact'">
          </lib-check-box>
          <div class="msg-container" *ngIf="!canDefault">
            <div class="msg d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
              </svg>
              <small class="ml-1">This contact will become the default contact.</small>
            </div>
          </div>
          <lib-check-box [control]="form.controls.isMarketingRecipient" [idName]="'market-recipient'"
            [label]="'Market Recipient'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isOrderProgressRecipient" [idName]="'order-progress-recipient'"
            [label]="'Order Progress Recipient'">
          </lib-check-box>
        </div>
        <div class="col-12 col-lg-6 pl-0">
          <lib-check-box [control]="form.controls.isShippingNotificationRecipient"
            [idName]="'shipping-notification-recipient'" [label]="'Shipping Notification Recipient'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isInvoiceRecipient" [idName]="'sales-invoice-recipient'"
            [label]="'Sales Invoice Recipient'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isCreditNoteRecipient" [idName]="'credit-note-recipient'"
            [label]="'Credit Note Recipient'">
          </lib-check-box>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="required-fields-container">
            <lib-required-fields [formGroup]="form"></lib-required-fields>
          </div>
          <div class="button-container">
            <button (click)="save(form)" class="btn btn-success ml-4">Save Contact</button>
          </div>
        </div>
      </div>
    </form>

  </ng-container>

  <ng-container *ngIf="state == 1">

    <p class="mb-4"><b>Customer has missing contact details that are required before this customer can be created in
        jControl</b></p>

    <form [formGroup]="form" *ngIf="form">
      <div class="row">
        <div class="col-12">
          <div class="col-12 col-lg-5 px-0 filter-item">
            <lib-select-box [control]="form.controls.title" [source]="titles" [labelBlock]="true" [idName]="'title'"
              [label]="'Title:'" [sourceType]="'Titles' | translate">
            </lib-select-box>
          </div>
          <div class="col-12 col-lg-8 px-0 filter-item">
            <lib-text-box [control]="form.controls.firstName" [labelBlock]="true" [idName]="'first-name'"
              [label]="'First Name:'" [maxLength]="40">
            </lib-text-box>
          </div>
          <div class="col-12 col-lg-8 px-0 filter-item">
            <lib-text-box [control]="form.controls.lastName" [labelBlock]="true" [idName]="'last-name'"
              [label]="'Last Name:'" [maxLength]="40">
            </lib-text-box>
          </div>
          <div class="col-12 px-0 filter-item">
            <lib-text-box [control]="form.controls.jobTitle" [labelBlock]="true" [idName]="'job-title'"
              [label]="'Job Title:'" [maxLength]="80">
            </lib-text-box>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="col-12 px-0 filter-item">
            <lib-text-box [control]="form.controls.emailAddress" [labelBlock]="true" [idName]="'email'"
              [label]="'Email Address:'" [maxLength]="255">
            </lib-text-box>
          </div>
          <!--switch to alert if the form is submitted without atleast one valid phone number-->
          <div [ngClass]="formSubmitted && !isValidPhoneNumberProvided() ? 'alert alert-danger' : 'text-secondary'">

            <div class="col-12 px-0 filter-item">

                <div class="mb-3">
                    A valid telephone or mobile number is required.
                </div>
                
                <phone-number-input [numberObj]="{number: form.controls.telephoneNumber.value}" [isRequired]="true" [size]="'md'"
                            (numberUpdated)="numberUpdated($event, form.controls.telephoneNumber)"
                            (numberVerifiedEmit)="checkIsVerified($event, 'telephoneNumber')"
                            [label]="'Phone Number:'"
                            [defaultCountryCode]="customerAddress?.details?.countryCode ? customerAddress?.details?.countryCode : undefined">
                </phone-number-input>

            </div>
            <div class="col-12  px-0 filter-item">

                <phone-number-input [numberObj]="{number: form.controls.mobileNumber.value}" [isRequired]="true" [size]="'md'"
                            (numberUpdated)="numberUpdated($event, form.controls.mobileNumber)"
                            (numberVerifiedEmit)="checkIsVerified($event, 'mobileNumber')"
                            [label]="'Mobile Number:'"
                            [defaultCountryCode]="customerAddress?.details?.countryCode ? customerAddress?.details?.countryCode : undefined">
                </phone-number-input>

            </div>

          </div>
        </div>
      </div>
      <!--div class="row mt-3">
            <div class="col-12 d-flex flex-row">
                <div class="col-10 px-0 filter-item">
                    <lib-select-box
                        [control]="form.controls.address"
                        [source]="savedAddresses"
                        [labelBlock]="true"
                        [fieldDescription]="'concatenatedAddress'"
                        [idField]="'postalCode'"
                        [idName]="'address'"
                        [label]="'Address:'">
                    </lib-select-box>
                </div>
                <div class="col-2 px-0 text-right text-lg-center">
                    <button class="btn btn-success" (click)="addAddress()">Add</button>
                </div>
            </div>
        </div-->
      <div class="row mt-3">
        <div class="col-12">
          <div class="col-12 col-lg-8 px-0 filter-item">
            <lib-select-box [control]="form.controls.language" [source]="languages" [idField]="'code'"
              [labelBlock]="true" [idName]="'language'" [label]="'Language:'" [sourceType]="'Languages' | translate">
            </lib-select-box>
          </div>
        </div>
      </div>
      <div class="row check-box-container">
        <div class="col-12 col-lg-6 pl-0 mb-lg-3">
          <lib-check-box [control]="form.controls.isDefault" [idName]="'default-contact'" [label]="'Default Contact'">
          </lib-check-box>
          <div class="msg-container" *ngIf="!canDefault">
            <div class="msg d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
              </svg>
              <small class="ml-1">This contact will become the default contact.</small>
            </div>
          </div>
          <lib-check-box [control]="form.controls.isMarketingRecipient" [idName]="'market-recipient'"
            [label]="'Market Recipient'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isOrderProgressRecipient" [idName]="'order-progress-recipient'"
            [label]="'Order Progress Recipient'">
          </lib-check-box>
        </div>
        <div class="col-12 col-lg-6 pl-0">
          <lib-check-box [control]="form.controls.isShippingNotificationRecipient"
            [idName]="'shipping-notification-recipient'" [label]="'Shipping Notification Recipient'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isInvoiceRecipient" [idName]="'sales-invoice-recipient'"
            [label]="'Sales Invoice Recipient'">
          </lib-check-box>
          <lib-check-box [control]="form.controls.isCreditNoteRecipient" [idName]="'credit-note-recipient'"
            [label]="'Credit Note Recipient'">
          </lib-check-box>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="required-fields-container">
            <lib-required-fields [formGroup]="form"></lib-required-fields>
          </div>
          <div class="button-container">
            <button (click)="saveUpdatedContact(form)" class="btn btn-success ml-4">Save Contact</button>
          </div>
        </div>
      </div>
    </form>

  </ng-container>

  <ng-container *ngIf="state == 2">

    <p class="mb-4"><b>You must select a default contact before this customer can be created in jControl</b></p>

    <form [formGroup]="form" *ngIf="form?.controls">
      <div class="row">
        <div class="col-12">
          <lib-select-box [control]="form.controls.defaultContact" [source]="savedContacts" [labelBlock]="true"
            [fieldDescription]="'concatenatedContact'" [idName]="'saved contacts'" [label]="'Default Contact:'">
          </lib-select-box>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="required-fields-container">
            <lib-required-fields [formGroup]="form"></lib-required-fields>
          </div>
          <div class="button-container">
            <button (click)="saveNewDefaultContact(form)" class="btn btn-success ml-4">Save Contact</button>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</ng-template>
